'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackEvent, EVENTS, setProperties } from '../lib/usageTracker';
import { selectHasReportsPaidAccessScope } from 'dashboard-lib/public/userInfo/scopes';
import { selectReportingIncreaseCountLimit } from 'dashboard-lib/public/userInfo/limits';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const EventTrackerWrapper = ({
  children
}) => {
  const hasReportingAddon = useSelector(selectHasReportsPaidAccessScope);
  const reportingIncreaseCount = useSelector(selectReportingIncreaseCountLimit);
  useEffect(() => {
    setProperties({
      hasReportingAddon,
      reportingIncreaseCount
    });
    trackEvent(EVENTS.pageView, {
      subscreen: 'reports-list'
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
EventTrackerWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
export default EventTrackerWrapper;